import { observer } from 'mobx-react';
import * as React from 'react';
import { getFieldVisibilityClass } from '../form/GravityFormFunctions';
function FieldContainer(props) {
    const { field, children } = props;
    const classNames = field.className.split(' ');
    const visibilityClass = getFieldVisibilityClass(field);
    if (visibilityClass) {
        classNames.push(visibilityClass);
    }
    if (!classNames.find((existingClassName) => existingClassName.startsWith('grid__col--xs'))) {
        classNames.unshift('grid__col--xs-12');
    }
    if (!classNames.includes('grid__col')) {
        classNames.unshift('grid__col');
    }
    const className = classNames.join(' ');
    return React.createElement("div", { className: className }, children);
}
export default observer(FieldContainer);
//# sourceMappingURL=FieldContainer.js.map